import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://awqivtmeufmrxaejhwbi.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF3cWl2dG1ldWZtcnhhZWpod2JpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0NTU0OTksImV4cCI6MjA4NTAzMTQ5OX0.ZptvlMs0MVbRKEpYNPXcgaElYwwjEmmochn0omJbFUU'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})